import adminFuseHoc from "common/HOC/adminFuseHoc";
import AdminCompaniesComponent from "./adminCompanies.component";

export default adminFuseHoc(AdminCompaniesComponent, {});
